/* global __webpack_modules__ */
/**
 * Check if angular is being resolved,
 * if it isn't then this doesn't matter... because react
 */
if (__webpack_modules__[require.resolveWeak('angular')]) {
  require('angular-slugify');
}
import territorySortFilter from './territorySortFilter';
import markdownFilter from './markdownFilter';
import filterSwitch from './switchFilter';

/**
 * Check if angular is being resolved,
 * if it isn't then this doesn't matter... because react
 */
if (__webpack_modules__[require.resolveWeak('angular')]) {
  module.exports = angular
    .module('datacenterFilters', ['slugifier'])
    .filter('filterSwitch', filterSwitch)
    .filter('markdown', markdownFilter)
    .filter('territorySort', territorySortFilter)
    .filter('percent', () => (value) => `${value}%`)
    .filter('rawCurrency', () => (value) => `$${value}`)
    .name;
} else {
  module.exports = (filterName) => {
    return {
      filterSwitch,
      markdown: markdownFilter,
      territorySort: territorySortFilter,
      percent: (value) => `${value}%`,
      rawCurrency: (value) => `$${value}`,
    }[filterName];
  };
}



// WEBPACK FOOTER //
// ../datacenter/app/js/filters/filters.js